<template>
  <div :class="$style.box">
    <header
      :class="$style.banner"
      :style="{
        backgroundImage: `url(
          ${$cdnUrl}/seckill/main/model/${
          !isLastDay ? 'qiangquan_biaoti1' : 'qiangquan_biaoti2'
        }.png)`,
      }"
    ></header>
    <div
      :class="[$style.content, isLastDay ? $style['last-content'] : '']"
      :style="{
        backgroundImage: `url(
          ${$cdnUrl}/seckill/main/model/${
          !isLastDay ? 'qiangquan_dikuang' : 'qiangquan_shouban'
        }.png)`,
      }"
    >
      <div
        v-for="(item, index) of list"
        :key="item.id"
        :class="[$style.item, isLastDay ? $style['last-item'] : '']"
      >
        <img
          :class="[$style.bg, item.status == 2 || item.status == 3 ? $style.grey : '']"
          :src="item.icon"
        />
        <div :class="$style.btns">
          <img
            :class="[item.status == 2 || item.status == 3 ? $style.grey : '']"
            :src="
              item.status == 5
                ? `${$cdnUrl}/seckill/main/model/anniu1.png`
                : `${$cdnUrl}/seckill/main/model/anniu${item.status}.png`
            "
            @click="handleSnatchVoucher(item, index)"
          />
          <img
            v-if="item.status == 2"
            :src="`${$cdnUrl}/seckill/main/model/qiangquan_zuorenwu.png`"
            @click="openTaskDialog"
          />
          <img
            v-if="item.status == 3"
            :src="`${$cdnUrl}/seckill/main/model/qiangquan_qushiyong.png`"
            @click="handleLink"
          />
        </div>
        <div v-show="item.showCount" :class="$style.time">
          抢夺倒计时：
          <van-count-down
            style="
              display: inline-block;
              font-size: 8px;
              font-weight: 400;
              color: #e5e311;
              line-height: 12px;
            "
            :time="handleTime(item.start_time)"
            @change="changeTime(item)"
          ></van-count-down>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CountDown, Toast } from 'vant';
import dayjs from 'dayjs';
import { seckillSnapUp, seckillUserInfo, forumBindAccount } from '@/api/activity.js';
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  components: {
    VanCountDown: CountDown
  },
  props: {
    currentVoucherList: {
      type: Array,
      default: () => []
    },
    isBindAccount: {
      type: Boolean,
      default: false
    },
    isFirstPay: {
      type: Boolean,
      default: false
    },
    isLastDay: {
      type: Boolean,
      default: false
    },
    isActStart: {
      type: Boolean,
      default: true
    },
    selectDate: {
      type: String,
      dafault: ''
    },
    // 获取服务器当前时间戳（秒）
    nowTimesTamp: {
      default: ''
    },
    snapUpArrProp: {
      type: Array,
      default: () => []
    },
    // 判断活动是否结束（超过最后一天配置的日期）
    isActEnd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [], // 代金券列表
      snapUpArr: [], // 用户获取代金券id数组
      clickFlag: false, // 抢劵按钮防止多次点击
    };
  },
  computed: {
    ...mapState('activity', {
      forumAccount: state => state.forumAccount
    }),
    // 活动id
    activityId() {
      return Number(this.$route.query.activity_id)
    },
    // 显示的是否是当天的代金券列表
    isToday() {
      return dayjs(this.selectDate).isSame(dayjs(this.nowTimesTamp), 'date')
    }
  },
  mounted() {
    this.handleList()
    this.timer = setInterval(() => {
      this.handleList()
    }, 1000);
    setTimeout(() => {
      if (this.isActEnd) return
      // 判断今日抢劵活动是否结束
      if (this.list.length && this.list.findIndex(item => item.status != 3 && item.status != 4) == -1) {
        this.$bus.$emit('openSeckillDialog', 'advanceNotice')
      }
    }, 1200);

  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING'
    }),
    ...mapActions('activity', {
      getForumBindAccount: 'getForumBindAccount',
    }),
    handleList() {
      this.list = this.currentVoucherList.length && this.currentVoucherList.map(item => {
        let time = item.start_time * 1000 - this.nowTimesTamp
        // status：可抢夺(1); 不可抢夺（2）；已抢到（3）;已抢完（4）;可抢夺但未到时间(5)；
        let status = 0
        // 活动未开始阶段
        if (time > 1000) {
          if (!this.isBindAccount || !this.isFirstPay) {
            status = 2
          } else {
            status = 5
          }
        }
        // 活动开始阶段(暂定5秒抢夺时间)
        if (time <= 1000 && time > -5000) {
          if (!this.isBindAccount || !this.isFirstPay) {
            status = 2
          } else {
            if (this.snapUpArrProp.includes(item.id) || this.snapUpArr.includes(item.id)) {
              status = 3
            } else {
              status = 1
            }
          }
        }
        // 活动结束阶段
        if (time <= -5000) {
          if (this.snapUpArrProp.includes(item.id) || this.snapUpArr.includes(item.id)) {
            status = 3
          } else {
            status = 4
          }
        }
        return Object.assign(item, {
          status
        })
      })
    },
    // 判断是否显示抢夺倒计时, 当距开始时间半个小时的时候显示倒计时
    changeTime(item) {
      let time = item.start_time * 1000 - this.nowTimesTamp
      if (time <= 1800000 && time >= -5000) {
        item.showCount = true
      } else {
        item.showCount = false
      }
    },
    handleTime(startTime) {
      let time = startTime * 1000 - this.nowTimesTamp
      return time
    },
    // 点击去做任务
    openTaskDialog() {
      if (!this.isActStart) {
        this.$toast('当前活动未开始，\n请于4月25日来参加哦！')
        return
      }
      this.CHANGE_SHOW_LOADING(true)
      this.getForumBindAccount().then(() => {
        this.CHANGE_SHOW_LOADING(false)
        if (!this.isBindAccount && this.forumAccount) {
          // 当平台已绑定，活动未绑定的时候弹出首次绑定弹窗
          this.$bus.$emit('openSeckillDialog', 'gameAccountTips')
          return
        }
        if (!this.isBindAccount && !this.forumAccount) {
          this.$bus.$emit('openSeckillDialog', 'showBindAccount')
          return
        }
        if (!this.isToday) {
          this.$toast(`${dayjs(this.selectDate).isBefore(dayjs(this.nowTimesTamp), 'date') ? '已过任务时间' : '任务未开始'}！`)
          return
        }
        if (!this.isFirstPay) {
          this.$bus.$emit('openSeckillDialog', 'firstTask')
        }
      })
    },
    handleLink() {
      this.$router.push({ name: "activity.userGuidance" });
    },
    // 开始抢券
    async handleSnatchVoucher(item, index) {
      if (!this.isActStart) {
        this.$toast('当前活动未开始，\n请于4月25日来参加哦！')
        return
      }
      if (item.snatch_success) return
      // 可抢夺(1); 不可抢夺（2）；已抢到（3）;已抢完（4）;可抢夺但未到时间(5)
      switch (parseInt(item.status)) {
        case 1:
          if (this.clickFlag) return
          this.clickFlag = true
          try {
            const r = await seckillSnapUp({
              lucky_draw_id: this.activityId,
              id: item.id
            })
            if (r.code) {
              Toast.success('抢夺成功')
              this.snapUpArr.push(item.id)
              item.snatch_success = true
              this.clickFlag = false
            }
          } catch (error) {
            if (error.message == '本场活动未开始') return
            if (error.message == '本场活动已结束') return
            Toast.fail(error.message)
            setTimeout(() => {
              this.clickFlag = false
            }, 500);
          }
          break;
        case 2:
          console.log('不可抢夺，需要完成任务');
          break;
        case 3:
          console.log('已抢到');
          break;
        case 4:
          console.log('已抢完');
          break;
        case 5:
          Toast('代金券抢夺时间未到！')
          break;
        case 6:
          console.log('活动快要开始了！');
          break;
        default:
          break;
      }
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/_variable';
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.banner {
  width: 90%;
  height: 25px;
  background-image: url('#{$cdn-url-hm}/seckill/main/model/qiangquan_biaoti1.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.content {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  position: relative;
  width: 360px;
  height: 257px;
  margin-top: 10px;
  padding: 5px 23px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  .item {
    position: relative;
    width: 309px;
    height: 70px;
    .bg {
      width: 98%;
      height: 57px;
    }
    .grey {
      filter: grayscale(80%);
      filter: rgb(12, 12, 12);
    }
    .btns {
      > img:first-child {
        position: absolute;
        top: 3px;
        right: 0;
        width: 66px;
        height: 53px;
      }
      > img {
        position: absolute;
        top: 20px;
        right: 56px;
        width: 65px;
        height: 21px;
      }
    }
    .time {
      float: right;
      margin-right: 10px;
      font-size: 8px;
      font-weight: 400;
      color: #e5e311;
    }
  }
}
.last-content {
  padding: 0px 23px;
  .last-item {
    position: absolute;
    bottom: 0;
    width: 370px;
    height: 58px;
    padding: 0 5px;
    .bg {
      width: 100%;
      height: 58px;
    }
    .btns {
      > img:first-child {
        position: absolute;
        top: 0px;
        right: 5px;
        width: 66px;
        height: 58px;
      }
    }
    .time {
      position: absolute;
      bottom: 5px;
      right: 73px;
    }
  }
}
</style>